// extracted by css-extract-rspack-plugin
export default {"root":"root--TWdi37hPv4aF3lUQ","year":"year--PRE16gtry0oUXyGH","hint":"hint--Gzu367oZQMIPYeOY"};